/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// import redux
import {
  resetBeneficiaryBankUpdate,
  resetUpdateBeneficiaryAccount,
} from "../../../../redux/features/accounts/beneficiaryAccount/index.js";

import { resetEditBankBeneficiary } from "../../../../redux/features/accounts/beneficiaryAccount/createAccount";

import { resetServices } from "../../../../redux/features/refreshToken/refreshToken";
import { requestTxnReject } from "../../../../redux/features/reimbursementRequest/index.js";
import { ReimbursementTxnDeniedApproval } from "../../../../redux/features/reimbursementTransaction/index.js";

// import components

import TEXT from "../../../../../src/utils/globalText";
import ICONS from "../../../../assets/Icons";
import CommonAlertsStrip from "../../../../components/_utils/CommonAlertsStrip/index.jsx";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavLargeButton from "../../../../components/_utils/CommonButtons/TopNavLargeButton";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import CommonToast from "../../../../components/_utils/CommonToast";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import TickerAnimation from "../../../../components/_utils/TickerAnimation";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import FullScreen from "../../../../components/FullScreen";
import Loader from "../../../../components/Loader/Index";
import ReimburseRequestViewAllPopup from "../../../../components/ReimbursementRequest/ReimburseRequestViewAllPopup/index.jsx";
import ReimbursementTxnViewAllPopup from "../../../../components/ReimbursementTxnViewAllPopup/index.jsx";
import useServiceChecker from "../../../../components/ServiceChecker";
import UserDetailsPopup from "../../../../components/Settings/User/UserDetailsPopup/index.jsx";
import GSTVerification from "../../../../containers/Settings/GSTDetails";
import IFSCDetails from "../../../../containers/Settings/IFSCDetails";
import PanVerification from "../../../../containers/Settings/PanVerification";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import useCategories from "../../../../utils/useCategories";
import ReimbursementRequestViewAll from "../../../ReimbursementRequest/ReimbursementRequestViewAll/index.jsx";
import ReimbursementTransactionsViewAll from "../../../Transactions/ReimbursementTransactions/ReimbursementTransactionViewAll";

import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import ConfirmCreateAccountPopup from "../../../../components/_utils/ConfirmCreateAccountPopup/index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import {
  achivedAccountDetail,
  addNewLabel,
  ReimburseApproveAccount,
  ReimburseRejectAccount,
  removeNewLabel,
  resetEditReimbursementAccount,
  setDetailDataToApprovalData,
  setDetailDataToRejectData,
  unachivedAccountDetail,
  viewAccountDetailR,
} from "../../../../redux/features/accounts/ReimburseAccount/index.js";
import {
  resetPanLookup,
  verifyPAN,
} from "../../../../redux/features/sharedResources/sharedResources.js";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";
import globalText from "../../../../../src/utils/globalText";

const ReimbursementAccountDetails = ({
  bene_account_id,
  type,
  closeBeneAccountDetailModal,
  showCategory,
  servicesType,
}) => {
  const labelActionDispatchedRef = useRef(false);
  const [ensureAll] = useServiceChecker();
  const categoryMapper = useCategories();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  let label;
  const pathName = location?.state?.from ? location?.state?.from : "";
  const txnSingleApproval = location?.state?.type ? location?.state?.type : "";

  const { viewAccountDetailData, ReimburseRejectData } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const {
    reimbursementRequestViewAllData,
    reimbursementRequestViewAllLoading,
  } = useSelector((state) => state.reimbursementRequest);

  const services = useSelector((state) => state.refreshToken.services);

  const sliceCategory = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const { reimbursementTxnViewAllLoading, reimbursementTxnViewAllData } =
    useSelector((state) => state?.reimbursementTransaction);

  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );
  const switcherScrollRef = useRef(null);

  //useState
  const [archiveloader, setArchiveLoader] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration?.mobileScreen,
  );
  const [clickedBtn, setClickedBtn] = useState("");
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [showHistoryPopup, setShowHistoryPopup] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [activeType, setActiveType] = useState("Pan");
  const [showPopupReject, setshowPopupReject] = useState(false);
  const [archiveType, setArchiveType] = useState("");
  const [userpopup, setUserpopup] = useState(false);
  const [requestRejectAll, setRequestRejectAll] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [viewAccountDetails, setViewAccountDetails] = useState([]);
  const [showGstPopup, setGstShowPopup] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [showIfscPopup, setIfscShowPopup] = useState(false);
  const [deniedId, setdeniedId] = useState(null);

  const [loading, setLoading] = useState(true);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false); // Isolated loading state for Label Popup

  const [nameArchive, setNameArchive] = useState("");
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    name: "",
    bank_name: "",
    ifsc_code: "",
    bank_acc_no: "",
    category: "",
    id: "",
    pan: "",
    bank_account_holder_full_name: "",
  });
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false); // show reject reimbursement txn popup
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labels, setLabels] = useState([]);
  const [labelDetails, setLabelDetails] = useState([]);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [txnHistoryId, setTxnHistoryId] = useState("");
  const [txnHistoryAccountName, setTxnHistoryAccountName] = useState("");
  const [declineReason, setDeclineReason] = useState("");
  const [associateType, setAssociateType] = useState("");
  const [category, setCategory] = useState("");
  const [bankDetails, setBankDetails] = useState({
    name: "",
    bankAccountNumber: "",
    ifscCode: "",
  });
  const [searchType, setSearchtype] = useState("");
  const [previousContactDetails, setPreviousContactDetails] = useState({
    legalName: "",
    contact: "",
    email: "",
    gstin: "",
    category: null,
    recipient_email: "",
  });

  const serviceCheckUser = JSON.parse(sessionStorage.getItem("response"))
    ?.employees?.id;
  const [index, setIndex] = useState(GlobalConfiguration?.lengthCheckZero);
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );

  const [animationClass, setAnimationClass] = useState("");
  // support info tool tip
  const supportInfoTTDefaultText = "Copy to clipboard";
  const [supportInfoTT, setSupportInfoTT] = useState(supportInfoTTDefaultText);

  const [requestHistory, setRequestHistory] = useState(false);

  const [currentAssociate, setCurrentAssociate] = useState(
    "Reimbursement account",
  );
  //function

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value
      .replace(/[^a-zA-Z0-9\s]/g, "")
      .replace(/^\s+/, "")
      .replace(/\s{2,}/g, " ");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  function handleChipClick(id) {
    if (selectedChipIndex === id) {
      setSelectedChipIndex(null);
    } else {
      setSelectedChipIndex(id);
    }
  }

  const chipsArray = [
    {
      text: globalText?.IFSC,
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckZero,
      disabled: true,
      hoverOption: "blue",
      bulletPoint: [
        "Contact the Xpentra administrator to change the IFSC detail.",
      ],
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckZero),
    },
    {
      text: "Name, User, Contact number, Email ID",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckOne,
      disabled: false,
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "Only the newly linked user will have access to this account after the change.",
      ],
      hoverOption: "blue",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckOne),
    },
    {
      text: "Categories",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckTwo,
      disabled: false,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckTwo),
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "Proceed with caution when assigning all categories to the same account.",
      ],
      hoverOption: "blue",
    },
    {
      text: "Recipients",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckThree,
      disabled: false,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckThree),
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "Account notifications will be sent to added recipients.",
      ],
      hoverOption: "blue",
    },
    {
      text: `${globalText?.PAN_NUMBER}, ${globalText?.GSTIN}`,
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckFour,
      disabled: false,
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "If GSTIN was entered during creation, it is required during editing.",
      ],
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckFour),
      hoverOption: "blue",
    },
    {
      text: "Bank account number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckFive,
      disabled: false,
      bulletPoint: [
        "It will be created as a new beneficiary account and archive the old account.",
        "New beneficiary account will remain pending and will require approval.",
        "Pending transactions associated with this account must be rejected.",
      ],
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckFive),
      hoverOption: "blue",
    },
  ];

  const handleConfirmDecline = async (id, AccountIdData) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    const data = await dispatch(ReimburseRejectAccount({ id, AccountIdData }));
    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "CReimbursementTxn",
        },
      });
      return;
    }

    setShowLoader(true);
    await new Promise((resolve) => {
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
    });

    if (data?.payload?.status === false || data?.payload === undefined) {
      let error_msg = "";
      let error_list = null;
      if (data?.payload === undefined) {
        error_msg = "An error occured while taking action on this account";
      } else if (data?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = data?.payload?.errors?.bank_account_number[0];
      } else if (data?.payload?.errors?.reimbursement_account) {
        if (
          data?.payload?.errors?.reimbursement_account?.length >
          GlobalConfiguration?.lengthCheckOne
        ) {
          error_list = data?.payload?.errors?.reimbursement_account;
          error_msg = data?.payload?.errors?.reimbursement_account[0];
        } else {
          error_msg = data?.payload?.errors?.reimbursement_account;
        }
      } else if (data?.payload?.errors?.reimbursement_account) {
        error_msg = data?.payload?.errors?.reimbursement_account[0];
      } else if (data?.payload?.status === false) {
        error_msg = data?.payload?.errors?.category?.[0];
      }

      if (error_msg === "Reimbursement account already rejected") {
        const newData = await dispatch(
          viewAccountDetailR({ id: bene_account_id || id }),
        );
        const updatedBeneficiaryAccount = {
          ...newData?.payload?.reimbursement_accounts?.[0],
          error_msg,
          error: data?.payload?.status === false ? true : false,
        };

        const updatedData = viewAccountDetails?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              ...(updatedBeneficiaryAccount || {}),
            };
          }
          return item;
        });
        updateAllAccounts(updatedData);
      } else {
        const updatedData = viewAccountDetails?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              error_msg,
              error: data?.payload?.status === false ? true : false,
            };
          }
          return item;
        });
        updateAllAccounts(updatedData);
      }
      setShowLoader(false);
      setDeclineReason("");
      handleClosePopup();
      if (
        Array.isArray(error_list) &&
        error_list.length > GlobalConfiguration?.lengthCheckOne
      ) {
        error_list.forEach((err) => {
          setTimeout(() => {
            CommonToast({
              text: err,
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text_primary)",
                enabledBgColor: "var(--primary_bg)",
              },
            });
          }, IntervalConfiguration?.intervalSmall);
        });
      } else {
        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text_primary)",
            enabledBgColor: "var(--primary_bg)",
          },
        });
      }
    } else {
      const updatedData = viewAccountDetails?.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? "rejected" : "pending",

            rejected_on:
              data?.payload?.status === true
                ? data?.payload?.reimbursement_accounts[0]?.rejected_on
                : "",
            rejected_by_name:
              data?.payload?.status === true
                ? data?.payload?.reimbursement_accounts[0]?.rejected_by_name
                : "",
            rejection_reason: AccountIdData,
            error:
              item.error === false && data?.payload?.status === false
                ? true
                : false,
            message:
              item.message === "" && data?.payload?.status === false
                ? data?.payload?.errors?.reimbursement_account[0]
                : "",
          };
        }
        return item;
      });
      updateAllAccounts(updatedData);
      setShowLoader(false);
      setDeclineReason("");
      handleClosePopup();

      CommonToast({
        text: "Account rejected successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (pathName) {
        setTimeout(() => {
          navigate(pathName);
        }, IntervalConfiguration.intervalExtraLarge);
      }
      if (type === "reimburseacc_details") {
        setTimeout(() => {
          closeBeneAccountDetailModal();
          window.location.reload();
        }, IntervalConfiguration.intervalExtraSmall);
      }
      dispatch(setDetailDataToRejectData());
    }
  };

  const handleApply = () => {
    dispatch(resetServices());

    dispatch(resetUpdateBeneficiaryAccount());
    dispatch(resetBeneficiaryBankUpdate());
    dispatch(resetEditReimbursementAccount());
    dispatch(resetEditBankBeneficiary());

    switch (selectedChipIndex) {
      case 0: // IFSC Code
        break;
      //
      case 1: // Account name, Contact number, Email
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_account_detail/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;

      case 2: // Assigned categories
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_categories/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;
      case 3: // Additional Recipient
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_recipient/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;

      case 4: // PAN Number, GST
        dispatch(resetPanLookup());
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_PAN_details/${id}`,
        );
        break;

      case 5:
        // Bank account number
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_bank_details/${id}`,
          {
            state: bankDetails,
          },
        );
        dispatch(resetBeneficiaryBankUpdate());
        break;

      default:
        break;
    }
  };

  async function fetchData(isSilent = false) {
    if (!isSilent) setLoading(true);
    try {
      let response;
      if (type === "reimburseacc_details") {
        response = await dispatch(viewAccountDetailR({ id: bene_account_id }));
      } else {
        response = await dispatch(
          viewAccountDetailR({ id: bene_account_id || id }),
        );
      }

      setLabelDetails(
        response?.payload?.reimbursement_accounts?.[0]?.labels || [],
      );
      setShowAdditionalRecipient(
        response?.payload?.reimbursement_accounts?.[0]?.recipient_email || [],
      );

      setLabels(response?.payload?.available_labels ?? []);
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("/*");
      }
    } catch (error) {
      console.error("Failed to load the account details", error);
    } finally {
      if (!isSilent) setLoading(false);
    }
  }

  const handleClose = () => {
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
    }
    setShowLabelsPopup(false);
  };
  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedChipIndex(null);
  };

  const handlePANDetails = async (pan) => {
    if (pan?.length === GlobalConfiguration?.panLength) {
      const response = await dispatch(verifyPAN({ search_string: pan }));
      if (response?.payload?.status === true) {
        setPanShowPopup(true);
      } else if (response?.payload?.errors?.user_unauthorized?.[0]) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "RUAccount",
          },
        });
      } else if (response?.payload?.status === false) {
        CommonToast({
          text: response?.payload?.errors?.base[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text_primary)",
            enabledBgColor: "var(--primary_bg)",
          },
        });
      }
    }
  };

  if (
    services?.find(
      (service) => service === "RAAccountArchive" || service === "Admin",
    ) === undefined &&
    viewAccountDetailData?.reimbursement_accounts?.[0]?.approval_status ===
      "archived"
  ) {
    label = (
      <>
        Unarchive <br /> account{" "}
      </>
    );
  } else {
    label = (
      <>
        Archive <br /> account{" "}
      </>
    );
  }

  const handleCloseModal = () => {
    setArchiveLoader(false);
    setUnachivedOpenPop(false);
    setAchivedOpenPop(false);
    setOpenBeneAssociate(false);
  };

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${bene_account_id}`,
    });
  };

  const handleUnarchive = () => {
    setUnachivedOpenPop(true);
    if (viewAccountDetailData?.reimbursement_accounts?.[0]?.archived === "N") {
      setUnachivedOpenPop(false);
    } else {
      setUnachivedOpenPop(true);
    }
  };
  const handleArchive = () => {
    if (viewAccountDetailData?.reimbursement_accounts?.[0]?.archived === "N") {
      setAchivedOpenPop(true);
    } else {
      setAchivedOpenPop(false);
    }
  };

  const toggleCategories = () => {
    setIndex(GlobalConfiguration.lengthCheckOne);
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setshowPopupReject(false);

    if (
      viewAccountDetailData?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_transactions === "Y"
    ) {
      setRejectTxnPopup(true);
    } else if (
      viewAccountDetailData?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_requests === "Y"
    ) {
      setRequestRejectAll(true);
    } else {
      handleConfirmDecline(id ? id : bene_account_id, AccountIdData);
    }
  };

  const openAssociatedAccountsFound = () => {
    setOpenBeneAssociate(true);
  };

  const handleApprovalDetails = async (id) => {
    let response;
    UniversalRefreshToast("approvalaccountsRefresh");
    setShowLoader(true);
    if (type === "reimburseacc_details") {
      response = await dispatch(ReimburseApproveAccount(bene_account_id));
    } else {
      response = await dispatch(ReimburseApproveAccount(id));
    }

    if (
      response?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "RAAccount",
        },
      });
      return;
    }
    if (
      response?.payload?.status === false ||
      response?.payload === undefined
    ) {
      let error_msg = "";
      if (response?.payload === undefined) {
        error_msg = "An error occured while taking action on this account";
      } else if (response?.payload?.errors?.reimbursement_account?.[0]) {
        error_msg = response.payload.errors.reimbursement_account[0];
      } else if (response?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = response.payload.errors.bank_account_number[0];
      } else {
        error_msg = "An unknown error occurred.";
      }
      if (error_msg === "Reimbursement account already approved") {
        const updatedData = viewAccountDetailData?.reimbursement_accounts.map(
          (item) => {
            if (
              item.id === (type === "reimburseacc_details")
                ? bene_account_id
                : id
            ) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "approved" : "pending",
              };
            }
            return item;
          },
        );
        setViewAccountDetails(updatedData);

        response = await dispatch(
          viewAccountDetailR({ id: bene_account_id || id }),
        );
      } else {
        const updatedData = viewAccountDetailData?.reimbursement_accounts.map(
          (item) => {
            if (
              item.id === (type === "reimburseacc_details")
                ? bene_account_id
                : id
            ) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "pending" : "",
                error_msg,
              };
            }
            return item;
          },
        );

        setViewAccountDetails(updatedData);
      }
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    } else {
      const updatedData = viewAccountDetailData?.reimbursement_accounts.map(
        (item) => {
          if (
            item.id === (type === "reimburseacc_details") ? bene_account_id : id
          ) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "approved" : "pending",
            };
          }
          return item;
        },
      );
      setViewAccountDetails(updatedData);

      response = dispatch(setDetailDataToApprovalData());
      const successMessage = "Account approved successfully.";

      CommonToast({
        text: successMessage,
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (type === "reimburseacc_details") {
        setTimeout(() => {
          closeBeneAccountDetailModal();
          window.location.reload();
        }, IntervalConfiguration.intervalExtraSmall);
      }

      if (txnSingleApproval === "txn_single_approval") {
        setTimeout(() => {
          navigate(-1);
        }, IntervalConfiguration.intervalExtraLarge);
      }
    }
    setShowLoader(false);
  };

  const handleDeclinedDetials = (id) => {
    setshowPopupReject(true);
    setdeniedId(id);
  };

  const handleClosePopup = () => {
    setshowPopupReject(false);
    setDeclineReason("");
  };
  const updateAllAccounts = (updatedAccounts) => {
    setViewAccountDetails(updatedAccounts);
  };

  const handleArchiveButton = async (id) => {
    setArchiveLoader(true);
    const accountInfo = viewAccountDetailData;

    if (
      accountInfo?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_transactions === "Y"
    ) {
      setArchiveType("archive");
      setAchivedOpenPop(false);
      setArchiveLoader(false);
      setRejectTxnPopup(true);
    } else if (
      accountInfo?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_requests === "Y"
    ) {
      setArchiveType("Requestarchive");
      setAchivedOpenPop(false);
      setArchiveLoader(false);
      setRequestRejectAll(true);
    } else {
      let thunkAction = achivedAccountDetail;

      UniversalRefreshToast("archive");
      const archived_response = await dispatch(thunkAction({ id, navigate }));
      if (
        archived_response.type !== "achivedAccountDetail/rejected" ||
        archived_response.payload === "Beneficiary account already archived"
      ) {
        await dispatch(viewAccountDetailR({ id: bene_account_id || id }));
      }
      handleCloseModal();
      setAchivedOpenPop(false);
    }
  };

  const archiveAccount = async (id) => {
    let thunkAction = achivedAccountDetail;

    UniversalRefreshToast("archive");
    const archived_response = await dispatch(thunkAction({ id, navigate }));
    if (
      archived_response.type !== "achivedAccountDetail/rejected" ||
      archived_response.payload === "Beneficiary account already archived"
    ) {
      await dispatch(viewAccountDetailR({ id: bene_account_id || id }));
    }
    handleCloseModal();
    setAchivedOpenPop(false);
    setArchiveLoader(false);
  };

  const handleUnArchiveButton = async () => {
    let thunkAction = unachivedAccountDetail;

    UniversalRefreshToast("unarchive");
    const unarchived_response = await dispatch(thunkAction({ id, navigate }));
    if (
      unarchived_response.type !== "unachivedAccountDetail/rejected" ||
      unarchived_response.payload === "Beneficiary account already pending"
    ) {
      await dispatch(viewAccountDetailR({ id: bene_account_id || id }));
    }
    setArchiveType("");
    handleCloseModal();
  };

  const handleModalOpen = (id) => {
    setIsEditModalOpen(id);
  };

  const handleArchiveRejectReimbursementTxn = async () => {
    setShowLoader(true);
    setshowPopupReject(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !reimbursementTxnViewAllLoading &&
      reimbursementTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? reimbursementTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        ReimbursementTxnDeniedApproval({ id: id2, AccountIdData }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AReimbursementTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setRejectTxnPopup(false);
      setTimeout(() => {
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalSmall);

      if (
        viewAccountDetailData?.reimbursement_accounts[0]
          ?.pending_reimbursement_requests === "Y"
      ) {
        setArchiveType("Requestarchive");
        setRequestRejectAll(true);
      } else {
        archiveAccount(id);
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setTimeout(() => {
      setRejectTxnPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setAssociateType("");
    }
    setShowLoader(false);
  };

  const handleRejectReimbursementTxn = async () => {
    setShowLoader(true);
    setshowPopupReject(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !reimbursementTxnViewAllLoading &&
      reimbursementTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? reimbursementTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        ReimbursementTxnDeniedApproval({ id: id2, AccountIdData }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AReimbursementTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setRejectTxnPopup(false);
      setTimeout(() => {
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalSmall);

      if (associateType === "ReimbursementTxn") {
        await dispatch(viewAccountDetailR({ id: bene_account_id || id }));
      }

      if (associateType === "rejectAccount") {
        if (
          viewAccountDetailData?.reimbursement_accounts[0]
            ?.pending_reimbursement_requests === "Y"
        ) {
          setRequestRejectAll(true);
          setRejectTxnPopup(false);
          await dispatch(viewAccountDetailR({ id: bene_account_id || id }));
        } else {
          handleConfirmDecline(id ? id : bene_account_id, AccountIdData);
        }
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setTimeout(() => {
      setRejectTxnPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setDeclineReason("");
      setAssociateType("");
    }
    setShowLoader(false);
  };

  const handleArchiveReject = () => {
    setAchivedOpenPop(false);
    setshowPopupReject(true);
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids?.[0]?.errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign, whichToast = "new") => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);

    // Optimistic UI Update
    setLabelDetails((prev) =>
      Array.from(new Set([...(prev || []), ...labelsToAssign])),
    );

    const res = await dispatch(
      addNewLabel({
        record_ids: toArray(id),
        labels: labelsToAssign,
      }),
    );

    if (addNewLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text:
          whichToast === "new"
            ? "New label assigned successfully."
            : "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      fetchData(true); // Silent Refresh
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      fetchData(true); // Sync failure
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    setLabelPopupLoading(false);
    return addNewLabel?.fulfilled?.match(res) ? true : false;
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    // Optimistic Update
    setLabelDetails((prev) =>
      (prev || []).filter((l) => !labelsToUnassign.includes(l)),
    );

    const res = await dispatch(
      removeNewLabel({
        record_ids: toArray(id),
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      fetchData(true); // Silent Refresh
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (removeNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      fetchData(true); // Sync Failure
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    setLabelPopupLoading(false);
    return removeNewLabel?.fulfilled?.match(res) ? true : false;
  };

  const asAcc =
    viewAccountDetailData?.reimbursement_accounts?.[0]?.associate_bank ===
      "Y" ||
    viewAccountDetailData?.reimbursement_accounts?.[0]?.associate_pan === "Y";

  const pendingTxn =
    viewAccountDetailData?.reimbursement_accounts?.[0]
      ?.pending_reimbursement_transactions === "Y";

  const pendingRequestTxn =
    viewAccountDetailData?.reimbursement_accounts?.[0]
      ?.pending_reimbursement_requests === "Y";

  const associatedCategories =
    viewAccountDetailData?.reimbursement_accounts?.[0]?.all_category_assign ===
    "Y";

  const buildAlerts = () => [
    ...(associatedCategories !== undefined
      ? associatedCategories
        ? [
            {
              isLoading: false,

              text: "All categories are assigned to this account",
              icon: ICONS?.ALERT,
              onClick: () => {
                toggleCategories();
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking category assign",
          },
        ]),
    ...(asAcc !== undefined
      ? asAcc
        ? [
            {
              isLoading: false,
              isDisabled: type === "reimburseacc_details",
              text: "Associated accounts found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (type === "reimburseacc_details") {
                  actionRestricted();
                } else {
                  openAssociatedAccountsFound();
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking associated account",
          },
        ]),

    ...(pendingTxn !== undefined
      ? pendingTxn &&
        viewAccountDetailData?.reimbursement_accounts?.[0]?.approval_status ===
          "pending"
        ? [
            {
              isLoading: false,
              isDisabled: type === "reimburseacc_details",
              text: "Pending transactions found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (type === "reimburseacc_details") {
                  actionRestricted();
                  return;
                } else {
                  setRejectTxnPopup(true);
                  setAssociateType("ReimbursementTxn");
                  setSearchtype("rejectall");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking pending transactions",
          },
        ]),

    ...(pendingRequestTxn !== undefined
      ? pendingRequestTxn &&
        viewAccountDetailData?.reimbursement_accounts?.[0]?.approval_status ===
          "pending"
        ? [
            {
              isLoading: false,
              isDisabled: type === "reimburseacc_details",
              text: "Pending requests found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (type === "reimburseacc_details") {
                  actionRestricted();
                } else {
                  setRequestRejectAll(true);
                  setAssociateType("RejectAllRequestTxn");
                  setSearchtype("rejectall");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking request pending transactions",
          },
        ]),
  ];

  const handleRejectRequestTxn = async () => {
    setShowLoader(true);
    setshowPopupReject(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !reimbursementRequestViewAllLoading &&
      reimbursementRequestViewAllData?.requests?.length >
        GlobalConfiguration.lengthCheckZero
        ? reimbursementRequestViewAllData?.requests?.map(
            (data) => data?.request_id,
          )
        : [];

    UniversalRefreshToast("Rejecting requests");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        requestTxnReject({ request_ids: id2, AccountIdData }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AReimbursementRequest";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
      setAchivedOpenPop(false);
      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setRejectTxnPopup(false);
      setRequestRejectAll(false);
      setTimeout(() => {
        CommonToast({
          text: "Requests rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalSmall);
      setshowPopupReject(false);
      if (associateType === "rejectAccount") {
        handleConfirmDecline(id ? id : bene_account_id, AccountIdData);
      } else if (archiveType === "Requestarchive") {
        archiveAccount(id);
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setTimeout(() => {
      setRejectTxnPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setDeclineReason("");
      setAssociateType("");
    }
    await dispatch(viewAccountDetailR({ id: bene_account_id || id }));
    setShowLoader(false);
  };

  const handleArchiveRejectRequest = () => {
    setAchivedOpenPop(false);
    setshowPopupReject(true);
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  // useEffect

  useEffect(() => {
    if (type === "reimburseacc_details" && showCategory) {
      setIndex(GlobalConfiguration.lengthCheckOne);
    }
  }, [showCategory]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.reimbursement_accounts &&
      viewAccountDetailData.reimbursement_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { pan_legal_name, contact_no, email_id, recipient_email } =
        viewAccountDetailData.reimbursement_accounts[0];
      setPreviousContactDetails({
        legalName: pan_legal_name,
        contact: contact_no,
        email: email_id,
        category: category || null,
        recipient_email,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.reimbursement_accounts &&
      viewAccountDetailData.reimbursement_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { category } = viewAccountDetailData.reimbursement_accounts[0];
      setCategory(category);
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.reimbursement_accounts &&
      viewAccountDetailData.reimbursement_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { bank_acc_no, name, ifsc_code } =
        viewAccountDetailData.reimbursement_accounts[0];
      setBankDetails({
        bankHolderName: name,
        bankAccountNumber: bank_acc_no,
        ifscCode: ifsc_code,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    fetchData();
  }, [bene_account_id, id]);

  useEffect(() => {
    if (
      !openBeneAssociate &&
      !achivedOpenPop &&
      !isEditModalOpen &&
      !showHistoryPopup &&
      !showLabelsPopup &&
      !showPanPopup &&
      !requestHistory &&
      !requestRejectAll &&
      !showRejectTnxPopup
    )
      return;

    const bodyOverflow = document.body.style.overflow;
    const documentOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = bodyOverflow;
      document.documentElement.style.overflow = documentOverflow;
    };
  }, [
    openBeneAssociate,
    achivedOpenPop,
    isEditModalOpen,
    showHistoryPopup,
    showLabelsPopup,
    showPanPopup,
    requestHistory,
    requestRejectAll,
    showRejectTnxPopup,
  ]);

  useEffect(() => {
    if (viewAccountDetailData) {
      setViewAccountDetails(viewAccountDetailData?.reimbursement_accounts);
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.reimbursement_accounts &&
      viewAccountDetailData.reimbursement_accounts.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      const {
        bank_name,
        bank_acc_no,
        category_ids,
        ifsc_code,
        id,
        pan_no,
        name,
      } = viewAccountDetailData.reimbursement_accounts[0];

      let x = categories?.filter((x) =>
        category_ids?.category_name?.includes(x.name),
      );
      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        category: category_ids?.map((x) => x.category_name).join(","),
        category_ids: category_ids.map((x) => x.category_id),
        ifsc_code,
        id,
        pan: pan_no,
        bank_account_holder_full_name: name,
        name,
        mergeCategory: x.length === 1 ? x[0].configuration.data : null,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration?.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    let accountData = [];
    if (viewAccountDetailData) {
      accountData = viewAccountDetailData?.reimbursement_accounts?.[0].logs;
    }
    if (
      accountData &&
      viewAccountDetailData?.reimbursement_accounts?.[0].archived === "Y"
    ) {
      setNameArchive(
        [...accountData]
          .filter((fil) => {
            return fil.action === "Archived";
          })
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))[0]
          .user_full_name,
      );
    }
  }, [viewAccountDetails]);

  useEffect(() => {
    sessionStorage.removeItem("PAN GST Edit NewValue");
  }, []);

  const switcherTabs = [
    {
      label: "Account details",
      key: "Account details",
    },
    {
      label: "Categories",
      key: "Categories",
    },
    {
      label: "Labels",
      key: "Labels",
    },
    {
      label: "Recipients",
      key: "Recipients",
    },
    {
      label: "Support details",
      key: "Support details",
    },
  ];

  useEffect(() => {
    if (!showCategory) {
      setIndex(GlobalConfiguration.lengthCheckZero);
    }
  }, [id]);

  useEffect(() => {
    const container = switcherScrollRef.current;
    if (!container) return;

    if (index === GlobalConfiguration.lengthCheckZero) {
      // first tab selected -> snap to start
      container.scrollTo({
        left: GlobalConfiguration.lengthCheckZero,
        behavior: "smooth",
      });
    } else if (
      index ===
      switcherTabs.length - GlobalConfiguration.lengthCheckOne
    ) {
      // last tab selected -> snap to end
      container.scrollTo({ left: container.scrollWidth, behavior: "smooth" });
    }
  }, [index]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const handleReimbursementLinkedUser = () => {
    if (type === "reimburseacc_details") {
      actionRestricted();
      return;
    }

    const reimbAcc = viewAccountDetailData?.reimbursement_accounts?.[0];

    if (!reimbAcc?.reimbursement_user_full_name) {
      CommonToast({
        text: "No user is linked to this account.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--error)",
        },
      });
      return;
    }

    const hasVSpecificEmp = ensureAll(["VSpecificEmp"])?.status;
    const hasAdmin = ensureAll(["Admin"])?.status;
    const reimbUserId =
      reimbAcc?.reimbursement_user_id || reimbAcc?.linked_user_id;

    const canViewLinkedUser =
      (hasVSpecificEmp && reimbUserId === serviceCheckUser) ||
      (hasVSpecificEmp && hasAdmin);

    if (canViewLinkedUser && reimbUserId) {
      setUserpopup(true);
      return;
    }

    const unavailableService = !hasVSpecificEmp
      ? "VSpecificEmp"
      : !hasAdmin
        ? "Admin"
        : "VSpecificEmp";

    navigate("/feature_not_assigned", {
      state: { unavailableService },
    });
  };

  const categoriesAssigned =
    viewAccountDetailData?.reimbursement_accounts?.[0]?.category_ids.map(
      (x) => [x.category_name, x.category_id],
    );

  const getApprovalStatusText = (account) => {
    switch (account?.approval_status) {
      case "error":
        return "Pending";
      case "pending":
        if (services?.includes("RAAccount") || services?.includes("Admin")) {
          return "Require approval";
        } else {
          return "Pending";
        }
      default:
        return account?.approval_status;
    }
  };
  return (
    <>
      <>{RestrictedActionPopup}</>
      {isEditModalOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <EditCommonPopup
            btnOneHandleFunction={handleModalClose}
            headerTitle="Select the option to edit:"
            alertText="Make sure you understand the impact before archiving."
            alertBackground="emphasis"
            chipsArray={chipsArray}
            btnOneText="Cancel"
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Edit"
            btnTwoHandleFunction={handleApply}
            btnTwoIsDisabled={
              selectedChipIndex === null ||
              selectedChipIndex === GlobalConfiguration.lengthCheckZero
            }
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            // btnTwoIsLoaderNeeded={handleLoading}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            defaultHeight={selectedChipIndex}
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {showPopupReject && (
        <div className="fixed top-top-base left-left-base w-full h-full  flex items-center justify-center z-max-zindex ">
          <div className="top-top-base left-left-base absolute w-full h-full bg-PopUp-BackDrop opacity-dark-opacity" />
          <SmallPopupWithInput
            headerTitle={
              associateType === "ReimbursementTxn" || archiveType === "archive"
                ? `Reject ${
                    reimbursementTxnViewAllData?.transactions?.length === 1
                      ? "transaction"
                      : "transactions"
                  }`
                : associateType === "RejectAllRequestTxn" ||
                    archiveType === "Requestarchive"
                  ? `Reject ${
                      reimbursementRequestViewAllData?.requests?.length === 1
                        ? "request"
                        : "requests"
                    }`
                  : "Reject account"
            }
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Provide the reason for rejection."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="Minimum 10 characters required."
            subtextwithbullet="Y"
            bulletPoints={
              associateType === "ReimbursementTxn" || archiveType === "archive"
                ? [
                    "Transaction will be rejected, and distribution will not be initiated.",
                    "Transaction cannot be edited.",
                  ]
                : associateType === "RejectAllRequestTxn" ||
                    archiveType === "Requestarchive"
                  ? [
                      "Once rejected, a new request should be created and no transaction will be initiated.",
                    ]
                  : [
                      "New requests and transactions cannot be created for this account.",
                      "Before rejecting this account, reject all associated transactions and requests.",
                      "Users can edit the rejected account to update details.",
                    ]
            }
            noteColor="text-secondary"
            inputPlaceholder={"Reason"}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputIsDisabled={showLoader ? true : false}
            btnOneIsDisabled={showLoader ? true : false}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (associateType === "ReimbursementTxn") {
                handleRejectReimbursementTxn();
              } else if (archiveType === "archive") {
                handleArchiveRejectReimbursementTxn();
              } else if (archiveType === "Requestarchive") {
                handleRejectRequestTxn();
              } else if (associateType === "RejectAllRequestTxn") {
                handleRejectRequestTxn();
              } else {
                handleRejectTransactionChecker(deniedId, declineReason);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoInActiveVariantNeeded={true}
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {/* Reject reimbursement transactions associated to the account */}
      {showRejectTnxPopup && (
        <div className="fixed top-top-base left-laft_base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop">
          <LargePopupRedirect
            headerTitle="Pending transactions found"
            headersubtext={`The following transactions are linked and need to be rejected before ${
              archiveType === "archive" ? "archiving" : "rejecting"
            } this account.`}
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setRejectTxnPopup(false);
              setDeclineReason("");
              setShowLoader(false);
              setAchivedOpenPop(false);
              setArchiveType("");
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={`To ${
              archiveType === "archive" ? "archive" : "reject"
            } the account, please reject the transactions listed above by clicking the "Reject all" button. The transactions will get rejected with the provided rejected reason.`}
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              const hasAccess = services?.find(
                (service) =>
                  service === "AReimbursementTxn" || service === "Admin",
              );
              if (!hasAccess) return;
              if (associateType === "ReimbursementTxn") {
                setshowPopupReject(true);
              } else if (archiveType === "archive") {
                handleArchiveReject();
              } else {
                handleRejectReimbursementTxn();
              }
            }}
            isLoaderNeeded={true}
            inActiveVariantNeeded
            isLoading={showLoader ? true : false}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={
              services?.find((service) => service === "AReimbursementTxn") ===
              undefined
            }
            disabledTextColor={"var(--text-primary)"}
            disabledBgColor={"var(--text-disabled)"}
          >
            <ReimbursementTransactionsViewAll
              TxnHistoryid={currentAccountDetails?.id}
              type={"reimburse_txnViewAll_popup"}
              alert={"alertpopup"}
              flow={"reimburse_txnViewAll_popup_reject"}
              closeRejectAllTxn={handleClosePopup}
              seachType={searchType}
              TxnHistoryAccountName={currentAccountDetails?.name}
            />
          </LargePopupRedirect>
        </div>
      )}

      {requestRejectAll && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Pending requests found"
              headersubtext={`The following requests are linked and need to be rejected before ${
                archiveType.toLowerCase().includes("archive")
                  ? "archiving"
                  : "rejecting"
              } this account.`}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              fullviewisDisabled={false}
              fullviewenabledTextColor="var(--text-primary)"
              fullviewenabledBgColor="var(--primary-nav)"
              fullviewhoverOption="white"
              fullviewicon={ICONS?.REDIRECT}
              fullviewdisabledBgColor="var(--text-disabled)"
              closeiconbtnType="button"
              closeiconhandleFunction={() => {
                setRequestRejectAll(false);
                setDeclineReason("");
              }}
              closeiconisDisabled={false}
              closeiconenabledBgColor="var(--primary-nav)"
              closeicondisabledBgColor="var(--text-disabled)"
              closeiconhoverOption="white"
              closeicon={ICONS?.CLOSE}
              bottomHeaderTextNeed={true}
              bottomHeaderText={`To ${
                archiveType.toLowerCase().includes("archive")
                  ? "archive"
                  : "reject"
              } the account, please reject the requests listed above by clicking the "Reject all" button. The requests will get rejected with the provided rejected reason.`}
              isbottomSectionneed={true}
              btnText={"Reject all"}
              confirmbtnrequired={true}
              handleFunction={() => {
                const hasAccess = services?.find(
                  (service) =>
                    service === "AReimbursementRequest" || service === "Admin",
                );
                if (!hasAccess) return;
                if (associateType === "RejectAllRequestTxn") {
                  setshowPopupReject(true);
                } else if (archiveType === "archive") {
                  handleArchiveRejectRequest();
                } else if (
                  archiveType === "Requestarchive" &&
                  viewAccountDetailData?.reimbursement_accounts?.[0]
                    ?.pending_reimbursement_transactions === "N"
                ) {
                  handleArchiveRejectRequest();
                } else {
                  handleRejectRequestTxn();
                }
              }}
              enabledBgColor={"var(--negative-act)"}
              hoverOption={"dark"}
              isLoaderNeeded={true}
              isLoading={showLoader ? true : false}
              enabledTextColor={"var(--text-primary)"}
              isDisabled={
                services?.find(
                  (service) => service === "AReimbursementRequest",
                ) === undefined
              }
              disabledTextColor={"var(--text-primary)"}
              disabledBgColor={"var(--text-disabled)"}
              inActiveVariantNeeded
            >
              <ReimbursementRequestViewAll
                type={"requestViewallPopup"}
                flow={"RequestRejectAll"}
                alert={"alertpopup"}
                TxnHistoryid={
                  viewAccountDetailData?.reimbursement_accounts?.[0]?.id
                }
                TxnHistoryAccountName={
                  viewAccountDetailData?.reimbursement_accounts?.[0]?.name
                }
                closeReimburseTxnDetailsModal={() => {
                  setRequestRejectAll(false);
                }}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}

      {showLabelsPopup && (
        <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={id}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={viewAccountDetailData?.reimbursement_accounts?.map(
              (acc) => ({ ...acc, labels: labelDetails }),
            )}
            labelActionDispatchedRef={labelActionDispatchedRef}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="details"
          />
        </div>
      )}

      {showHistoryPopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <ReimbursementTxnViewAllPopup
              closeReimburseTxnDetailsModal={() => {
                setShowHistoryPopup(false);
              }}
              TxnHistoryid={txnHistoryId}
              TxnHistoryAccountName={txnHistoryAccountName}
              type={"reimburse_txnViewAll_popup"}
              HistoryPopup={showHistoryPopup}
            />
          </div>
        </>
      )}
      {requestHistory && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <ReimburseRequestViewAllPopup
              closeReimburseTxnDetailsModal={() => {
                setRequestHistory(false);
              }}
              TxnHistoryid={txnHistoryId}
              TxnHistoryAccountName={txnHistoryAccountName}
              type={"requestViewallPopup"}
              flow="requestHistory"
            />
          </div>
        </>
      )}
      {showGstPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: viewAccountDetails?.[0]?.gstin_detail,
            })
          }
          closeiconhandleFunction={() => setGstShowPopup(false)}
        >
          <GSTVerification
            gst_number={viewAccountDetails?.[0]?.gstin_detail}
            popup={true}
          />
        </LargePopupRedirect>
      )}

      {showIfscPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="IFSC Details"
            isfullViewrequired={true}
            smallPopupHeader={"Open in full view?"}
            fullviewhandleFunction={() =>
              navigate(
                `/settings/IFSC_verification/IFSC_Details/${viewAccountDetails?.[0]?.ifsc_code}`,
              )
            }
            closeiconhandleFunction={() => setIfscShowPopup(false)}
          >
            <IFSCDetails
              ifsc_code={viewAccountDetails?.[0]?.ifsc_code}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state: viewAccountDetails?.[0]?.pan_no,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={viewAccountDetails?.[0]?.pan_no}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-full h-full flex items-center bg-Primary-black justify-center z-z-index-max bg-dark-opacity">
          <FullScreen
            id={bene_account_id}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}
      {userpopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <UserDetailsPopup
            User_account_id={viewAccountDetails?.[0]?.reimbursement_user_id}
            type={"User_details"}
            closeBeneAccountDetailModal={() => {
              setUserpopup(false);
            }}
          />
        </div>
      )}

      <div
        id="webviewdetailPage"
        className="h-full flex flex-col"
      >
        <div
          className={`main-div flex flex-col flex-1 ${type === "reimburseacc_details" ? "h-full" : "h-screen"}  ${
            achivedOpenPop || isEditModalOpen || openBeneAssociate
              ? "overflow-hidden"
              : type === "reimburseacc_details"
                ? "overflow-x-hidden"
                : "overflow-auto overflow-x-hidden"
          }`}
        >
          {loading ? (
            <div
              className={
                "loader-container absolute inset-0 flex items-center justify-center"
              }
            >
              <Loader />
            </div>
          ) : (
            <>
              <div
                className={`  bg-primary-nav mt-margin-base fixed top-top-base left-left-base w-full z-z-index-overlay shadow-box-shadow-bottom ${type === "reimburseacc_details" && "hidden"} Qsmd:hidden Qlg:px-padding-base `}
              >
                <div
                  className={` w-full flex ${type === "reimburseacc_details" ? "hidden" : "block"}`}
                >
                  <TopNavComponent
                    isFormattingNotRequired={true}
                    topNavHeader={"Reimbursement"}
                    topNavSubText="Accounts details"
                  />
                </div>{" "}
              </div>
              <div
                className={` h-auto Qmd:bg-primary-nav bg-primary-card ${
                  type === "reimburseacc_details" ? null : "main-alignment"
                }`}
              >
                {openBeneAssociate && (
                  <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
                    <ConfirmCreateAccountPopup
                      pan={
                        viewAccountDetailData?.reimbursement_accounts[0]?.pan_no
                      }
                      ifsc={
                        viewAccountDetailData?.reimbursement_accounts[0]
                          ?.ifsc_code
                      }
                      bank={
                        viewAccountDetailData?.reimbursement_accounts[0]
                          ?.bank_acc_no
                      }
                      activeAssociateId={
                        viewAccountDetailData?.reimbursement_accounts[0]?.id
                      }
                      activeType={activeType}
                      setActiveType={setActiveType}
                      setShowModalPopup={setOpenBeneAssociate}
                      dropDownNo={GlobalConfiguration?.lengthCheckOne}
                      currentAssociate={currentAssociate}
                      setCurrentAssociate={setCurrentAssociate}
                      associateType={"reimbursement"}
                    />
                  </div>
                )}
                {unachivedOpenPop && (
                  <div
                    onClick={() => setUnachivedOpenPop(false)}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <SmallPopupWithBulletPoints
                      headerTitle={"Confirm unarchiving this account?"}
                      // subtext="Unarchiving this account will make it active again and set its status to pending."
                      bulletPoints={[
                        "This account will become active.",
                        "The status will be changed to pending and will require approval.",
                      ]}
                      btnOneText="Cancel"
                      btnOneBtnType="button"
                      btnOneEnabledBgColor="transparent"
                      btnOneHandleFunction={handleCloseModal}
                      btnOneOutLineColor="var(--text-primary)"
                      btnOneEnabledTextColor="var(--text-primary)"
                      btnOneIsDisabled={false}
                      btnOneHoverOption="white"
                      btnTwoText="Unarchive"
                      btnTwoBtnType="button"
                      btnTwoHandleFunction={handleUnArchiveButton}
                      btnTwoEnabledBgColor="var(--positive-act)"
                      btnTwoEnabledTextColor="var(--text-primary)"
                      btnTwoIsDisabled={false}
                      btnTwoHoverOption="black"
                    />
                  </div>
                )}
                {achivedOpenPop && (
                  <div
                    onClick={() => setAchivedOpenPop(false)}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <div>
                      <SmallPopupWithBulletPoints
                        headerTitle={"Confirm archiving this account?"}
                        headerFontWeight="semibold"
                        headerFontColor="text-primary"
                        textSize="font-md"
                        // subtext="Archiving this account will make this account inactive and it cannot be used to create transactions unless unarchived."
                        btnOneText="Cancel"
                        bulletPoints={[
                          "This account will become inactive.",
                          "Account cannot be used unless unarchived.",
                        ]}
                        btnOneBtnType="button"
                        btnOneEnabledBgColor="transparent"
                        btnOneHandleFunction={handleCloseModal}
                        btnOneOutLineColor="var(--text-primary)"
                        btnOneEnabledTextColor="var(--text-primary)"
                        btnOneIsDisabled={false}
                        btnOneHoverOption="white"
                        btnTwoIsLoaderNeeded={true}
                        btnTwoIsLoading={archiveloader ? true : false}
                        btnTwoText="Archive"
                        btnTwoBtnType="button"
                        btnTwoHandleFunction={() => {
                          setArchiveLoader(true);
                          setArchiveType("archive");
                          handleArchiveButton(
                            viewAccountDetailData?.reimbursement_accounts?.[0]
                              ?.id,
                          );
                        }}
                        btnTwoEnabledBgColor="var(--negative-act)"
                        btnTwoEnabledTextColor="var(--text-primary)"
                        btnTwoIsDisabled={false}
                        btnTwoHoverOption="black"
                      />
                    </div>
                  </div>
                )}

                <div
                  className={`w-full max-w-screen-Qlg m-auto Qmd:bg-primary-nav bg-primary-card ${type === "reimburseacc_details" ? "" : "Qlg:mt-margin-sm"} `}
                  id="container"
                >
                  <div className="flex w-full bg-primary-nav  m-auto h-height-sm  Qlg:px-padding-base px-padding-base">
                    <div
                      className={`w-width-full px-padding-base Qsmd:px-padding-md Qlg:px-padding-base ${type === "reimburseacc_details" ? "" : "pt-padding-xs"}   ${
                        type === "reimburseacc_details"
                          ? ""
                          : "mt-margin-base Qsmd:mt-margin-lg"
                      }`}
                    >
                      {viewAccountDetailData?.reimbursement_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="flex border-b border-solid border-primary-bg justify-between mx-margin-md Qsmd:mx-margin-base"
                          >
                            <div className="flex flex-col Qsmd:flex-row w-full pt-padding-xs">
                              <div className="py-padding-md w-full Qsmd:w-right-half border-b Qsmd:border-b-border-base border-solid border-primary-bg">
                                <div className="flex flex-col Qsmd:border-r border-solid border-primary-bg Qsmd:pl-padding-sm pr-padding-base Qsmd:pr-padding-md">
                                  <TitleSubtitlePair
                                    title={account.name.trim()}
                                    titleColor="text-primary "
                                    subtitle={
                                      account?.name?.trim() ===
                                      account?.pan_legal_name?.trim()
                                        ? "Account name - Using legal name"
                                        : "Account name"
                                    }
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                              </div>

                              {viewAccountDetails?.map((account) => (
                                <div
                                  key={account?.id}
                                  className="w-full Qsmd:w-right-half py-padding-md"
                                >
                                  <div className="flex flex-col items-start Qsmd:pl-padding-md">
                                    <TitleSubtitlePair
                                      titleCase="sentence"
                                      title={getApprovalStatusText(account)}
                                      titleColor={`${
                                        account?.approval_status ===
                                          "pending" ||
                                        account?.approval_status === "error"
                                          ? "pending"
                                          : account?.approval_status ===
                                              "approved"
                                            ? "awaiting"
                                            : account?.approval_status ===
                                                "rejected"
                                              ? "failed"
                                              : account?.approval_status ===
                                                  "blocked"
                                                ? "failed"
                                                : account?.approval_status ===
                                                    "archived"
                                                  ? "abandoned"
                                                  : ""
                                      }`}
                                      subtitle="Account status"
                                      alignRight={false}
                                      hoverOption="white"
                                      isBold={true}
                                      variant="md"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div
                              className={`associated-account-transaction-history-block Qsmd:flex flex-row ${type === "reimburseacc_details" && " opacity-light-opacity"} bg-primary-nav-act hidden`}
                            >
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Linked <br /> user
                                  </>
                                }
                                handleFunction={handleReimbursementLinkedUser}
                                icon={ICONS?.LINKED_WHITE_CIRCLE}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                isDisabled={
                                  type === "reimburseacc_details"
                                    ? true
                                    : services?.find(
                                          (service) =>
                                            service === "VSpecificEmp" ||
                                            service === "Admin",
                                        ) !== undefined &&
                                        account?.reimbursement_user_full_name
                                      ? false
                                      : account?.reimbursement_user_full_name
                                        ? false
                                        : true
                                }
                                hoverOption="white"
                              />
                              <div className="py-padding-button-l flex ">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Associated <br></br> accounts
                                  </>
                                }
                                handleFunction={() => {
                                  if (type === "reimburseacc_details") {
                                    actionRestricted();
                                    return;
                                  }
                                  openAssociatedAccountsFound();
                                }}
                                icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                isDisabled={
                                  type === "reimburseacc_details" ? true : false
                                }
                                hoverOption="white"
                              />

                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>

                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Transaction <br /> history
                                  </>
                                }
                                handleFunction={() => {
                                  if (type === "reimburseacc_details") {
                                    actionRestricted();
                                    return;
                                  }
                                  if (ensureAll(["VReimbursementTxn"]).status) {
                                    setShowHistoryPopup(true);
                                    setTxnHistoryAccountName(
                                      account?.bank_account_holder_full_name,
                                    );
                                    setTxnHistoryId(account?.id);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "VReimbursementTxn",
                                      },
                                    });
                                    return;
                                  }
                                }}
                                icon={ICONS?.TRANSACTION_HISTORY}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                hoverOption="white"
                                isDisabled={
                                  type === "reimburseacc_details" ||
                                  !ensureAll(["VReimbursementTxn"]).status
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </div>
                        ),
                      )}
                      {viewAccountDetailData?.reimbursement_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="bene-account-holder-details flex border-b border-solid border-primary-bg justify-between Qsmd:mx-margin-base mx-margin-md"
                          >
                            <div className="flex flex-col Qsmd:flex-row w-full ">
                              <div className="flex w-full Qsmd:w-width-md justify-between Qsmd:border-b-border-base border-b border-solid border-primary-bg">
                                <div className="py-padding-md Qsmd:pl-padding-sm flex flex-col w-full Qsmd:w-right-half ">
                                  <TitleSubtitlePair
                                    title={formatAccountNumber(
                                      account?.bank_acc_no,
                                    )}
                                    titleColor="text-primary"
                                    subtitle="Account number"
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                                <div className="h-[max-content] flex justify-center items-center bg-text-primary rounded-border-radius-md mb-margin-md mt-margin-lg Qsmd:mr-margin-md">
                                  <CommonBankLogo
                                    ifsc={account?.ifsc_code}
                                    variant="big"
                                    type="pill"
                                  />
                                </div>
                              </div>
                              <div className="py-padding-md w-full Qsmd:w-right-half">
                                <div className="flex flex-col items-start Qsmd:px-padding-md Qsmd:border-l border-l-border-base border-solid border-primary-bg">
                                  <TitleSubtitlePair
                                    title={
                                      account.bank_account_holder_full_name
                                    }
                                    titleColor="text-primary"
                                    subtitle="Bank account holder's name"
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className={`settings Qsmd:flex flex-row hidden justify-end ${type === "reimburseacc_details" && "opacity-light-opacity"} bg-primary-nav-act`}
                            >
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    {" "}
                                    Request <br /> history
                                  </>
                                }
                                handleFunction={() => {
                                  if (type === "reimburseacc_details") {
                                    actionRestricted();
                                    return;
                                  }
                                  if (ensureAll(["VReimbursementTxn"]).status) {
                                    setRequestHistory(true);
                                    setTxnHistoryAccountName(
                                      account?.bank_account_holder_full_name,
                                    );
                                    setTxnHistoryId(account?.id);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "VReimbursementTxn",
                                      },
                                    });
                                    return;
                                  }
                                }}
                                icon={ICONS?.TRANSACTION_HISTORY}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary"}
                                hoverOption="white"
                                isDisabled={
                                  type === "reimburseacc_details" ||
                                  !ensureAll(["VReimbursementTxn"]).status
                                    ? true
                                    : false
                                }
                              />
                              <div className="py-padding-button-l flex bg-primary-nav-act">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    {" "}
                                    Edit <br /> account
                                  </>
                                }
                                handleFunction={() => {
                                  if (
                                    viewAccountDetailData
                                      ?.reimbursement_accounts?.[0]
                                      .approval_status !== "archived" &&
                                    viewAccountDetailData
                                      ?.reimbursement_accounts?.[0]
                                      .approval_status !== "blocked"
                                  ) {
                                    if (type === "reimburseacc_details") {
                                      actionRestricted();
                                    } else {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "RUAccount" ||
                                            service === "Admin",
                                        ) !== undefined
                                      ) {
                                        dispatch(
                                          resetEditReimbursementAccount(),
                                        );
                                        handleModalOpen(id);
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "RUAccount",
                                          },
                                        });
                                      }
                                    }
                                  }
                                }}
                                icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary"}
                                hoverOption="white"
                                isDisabled={
                                  type === "reimburseacc_details"
                                    ? true
                                    : viewAccountDetailData
                                          ?.reimbursement_accounts[0]
                                          .approval_status === "archived" ||
                                        viewAccountDetailData
                                          ?.reimbursement_accounts?.[0]
                                          .approval_status === "blocked"
                                      ? true
                                      : services?.find(
                                            (service) =>
                                              service === "RUAccount" ||
                                              (service === "Admin" &&
                                                servicesType !== "BenAdmin"),
                                          ) !== undefined
                                        ? false
                                        : true
                                }
                              />

                              <div className="py-padding-button-l flex bg-primary-nav-act">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>

                              <TopNavSmallButton
                                btnText={
                                  viewAccountDetailData
                                    ?.reimbursement_accounts[0]
                                    .approval_status === "archived" ? (
                                    <>
                                      Unarchive <br /> account{" "}
                                    </>
                                  ) : (
                                    <>
                                      Archive <br /> account{" "}
                                    </>
                                  )
                                }
                                handleFunction={() => {
                                  if (
                                    viewAccountDetailData
                                      ?.reimbursement_accounts[0]
                                      .approval_status !== "blocked"
                                  ) {
                                    if (type === "reimburseacc_details") {
                                      actionRestricted();
                                    } else if (
                                      services?.find(
                                        (service) =>
                                          service === "RAAccountArchive" ||
                                          service === "Admin",
                                      ) !== undefined
                                    ) {
                                      handleUnarchive();
                                      handleArchive();
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService:
                                            "RAAccountArchive",
                                        },
                                      });
                                    }
                                  }
                                }}
                                icon={
                                  viewAccountDetailData
                                    ?.reimbursement_accounts[0]
                                    .approval_status === "archived"
                                    ? ICONS?.UNARCHIVE
                                    : ICONS?.ARCHIVE
                                }
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary"}
                                hoverOption="white"
                                isDisabled={
                                  type === "reimburseacc_details"
                                    ? true
                                    : viewAccountDetailData
                                          ?.reimbursement_accounts[0]
                                          .approval_status === "blocked"
                                      ? true
                                      : services?.find(
                                            (service) =>
                                              service === "RAAccountArchive" ||
                                              service === "Admin",
                                          ) === undefined
                                        ? true
                                        : false
                                }
                              />
                            </div>
                          </div>
                        ),
                      )}
                      {viewAccountDetailData?.reimbursement_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="bene-account-holder-details flex justify-between, flex-col Qsmd:flex-row overflow-x-hidden "
                          >
                            <div className="flex Qmd:flex-row flex-1">
                              <div
                                className={`flex justify-between w-full ${account?.approval_status === "archived" || account?.approval_status === "blocked" || account?.approval_status === "rejected" ? " lg:w-width-lg" : "lg:w-right-half "}  Qlg:my-margin-sm mx-margin-sm Qsmd:mx-margin-base py-padding-sm Qlg:py-padding-base `}
                              >
                                <div
                                  className={` ${type === "reimburseacc_details" && "opacity-light-opacity"} `}
                                >
                                  <TitleSubtitlePair
                                    title={account?.ifsc_code}
                                    titleColor="text-primary "
                                    isDisabled={
                                      type === "reimburseacc_details"
                                        ? true
                                        : false
                                    }
                                    subtitle={globalText?.IFSC}
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                    showArrow="true"
                                    onClick={() => {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "VIFSC" ||
                                            service === "Admin",
                                        ) !== undefined &&
                                        account?.ifsc_code
                                      ) {
                                        if (type === "reimburseacc_details") {
                                          actionRestricted();
                                        } else {
                                          setIfscShowPopup(true);
                                        }
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "VIFSC",
                                          },
                                        });
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                className={`${account?.approval_status === "archived" || account?.approval_status === "blocked" || account?.approval_status === "rejected" ? "  lg:w-width-lg" : ""}`}
                              ></div>
                              <div
                                className={`py-padding-md  lg:w-width-md ${account?.approval_status === "archived" || account?.approval_status === "blocked" || account?.approval_status === "rejected" ? "  lg:w-width-md" : " Qsmd:w-width-sm-1-3"} flex justify-between ${
                                  viewAccountDetails[0]?.approval_status ===
                                    "rejected" ||
                                  (viewAccountDetails[0]?.approval_status ===
                                    "pending" &&
                                    viewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration.lengthCheckZero)
                                    ? "denied-ifsc-div"
                                    : ""
                                }`}
                              >
                                <div
                                  className={`account-ifsc-div-main  flex flex-row pl-padding-sm Qmd:pl-padding-md w-full `}
                                ></div>
                              </div>
                            </div>
                            <div
                              className={`flex justify-end w-full Qsmd:w-failed-to-take-action-card-width Qmd:h-auto  ${
                                (viewAccountDetails[0]?.approval_status ===
                                  "blocked" ||
                                  viewAccountDetails[0]?.approval_status ===
                                    "archived" ||
                                  viewAccountDetails[0]?.approval_status ===
                                    "rejected") &&
                                "hidden"
                              }`}
                            >
                              <div
                                className={`${
                                  (viewAccountDetails[0]?.approval_status ===
                                    "rejected" &&
                                    viewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration.lengthCheckZero) ||
                                  (viewAccountDetails[0]?.approval_status ===
                                    "pending" &&
                                    viewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration.lengthCheckZero)
                                    ? "w-full"
                                    : " w-full "
                                }`}
                              >
                                <div className="h-full w-full flex justify-end">
                                  {viewAccountDetails?.map((account) => (
                                    <>
                                      {showLoader ? (
                                        <div className="w-full Qsmd:w-max-button-width-for-approval-animation flex justify-end">
                                          <div
                                            className={`w-width-full flex justify-center items-center py-padding-lg ${
                                              clickedBtn === "reject"
                                                ? "bg-negative-act"
                                                : "bg-positive-act"
                                            }`}
                                          >
                                            <Loader
                                              height="var(--icon-lg)"
                                              width="var(--icon-lg)"
                                            />
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                        "approved" ? (
                                        <>
                                          <TopNavLargeButton
                                            isDisabled={
                                              ensureAll([
                                                "CReimbursementTxn",
                                                "AReimbursementRequest",
                                              ]).status
                                                ? false
                                                : true
                                            }
                                            hoverOption={"black"}
                                            btnText={<>Pay now</>}
                                            btnType={"button"}
                                            handleFunction={() => {
                                              toast.dismiss();
                                              if (
                                                !ensureAll([
                                                  "CReimbursementTxn",
                                                  "AReimbursementRequest",
                                                ]).status
                                              ) {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService: [
                                                        "CReimbursementTxn",
                                                        "AReimbursementRequest",
                                                      ],
                                                    },
                                                  },
                                                );
                                              } else {
                                                if (
                                                  !viewAccountDetailData
                                                    ?.reimbursement_accounts?.[0]
                                                    ?.category_ids?.length
                                                ) {
                                                  CommonToast({
                                                    text: "Category can't be blank",
                                                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                                    variant: "var(--error)",
                                                    btnProps: {
                                                      isDisabled: false,
                                                      enabledTextColor:
                                                        "var(--text_primary)",
                                                      enabledBgColor:
                                                        "var(--primary_bg)",
                                                    },
                                                  });
                                                } else {
                                                  navigate(
                                                    "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
                                                    {
                                                      state: {
                                                        ...currentAccountDetails,
                                                        type: "payReimbursementdetails",
                                                      },
                                                    },
                                                  );
                                                }
                                              }
                                            }}
                                            icon={ICONS?.REIMBURSEMENT_DETAIL}
                                            enabledBgColor={
                                              "var(--positive-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary)"
                                            }
                                            fullWidthRequired={isMobile}
                                          />
                                        </>
                                      ) : account?.approval_status ===
                                          "rejected" &&
                                        account?.error_msg?.length >
                                          GlobalConfiguration?.lengthCheckZero ? (
                                        <div
                                          key={account.id}
                                          className={`h-full flex justify-end  ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                (service ===
                                                  "CReimbursementTxn" &&
                                                  service ===
                                                    "AReimbursementRequest") ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm">
                                            <div className="flex place-items-center">
                                              <img
                                                src={
                                                  ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                                }
                                                alt="Not  found"
                                              />
                                            </div>
                                            <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                              <span className="font-semibold font-sans text-xs text-text-primary">
                                                Failed to take action
                                              </span>

                                              <span className="font-sans text-font_xxs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                          "pending" &&
                                        account?.error_msg?.length >
                                          GlobalConfiguration?.lengthCheckZero ? (
                                        <div
                                          key={account?.id}
                                          className={`h-full w-full lg:flex lg:justify-end ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                (service ===
                                                  "CReimbursementTxn" &&
                                                  service ===
                                                    "AReimbursementRequest") ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <div className="flex flex-row h-full w-full bg-negative-card p-padding-sm gap-gap-sm">
                                            <div className="flex place-items-center">
                                              <img
                                                src={
                                                  ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                                }
                                                alt="Not found"
                                                className="w-icon-lg h-icon-lg mr-margin-button-m"
                                              />
                                            </div>
                                            <div className="flex flex-col justify-center gap-y-gap-xs w-5/6 ">
                                              <span className="font-semibold font-sans text-sm text-text-primary">
                                                Failed to take action
                                              </span>

                                              <span className="font-sans text-xs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                        "error" ? (
                                        <div className="flex flex-row h-full bg-negative-card p-padding-sm">
                                          <div className="flex place-items-center ">
                                            <img
                                              src={
                                                ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                              }
                                              alt="Not found"
                                              className="w-icon-lg h-icon-lg mr-margin-button-m"
                                            />
                                          </div>
                                          <div className="flex flex-col justify-center gap-y-gap-xs w-5/6">
                                            <span className="font-semibold font-sans text-sm text-text-primary">
                                              Failed to take action
                                            </span>
                                            <div>
                                              <p className="line-clamp-3 whitespace-wrap overflow-ellipsis text-font_xs text-text-secondary opacity-base_opacity">
                                                {account?.error_msg
                                                  ? account?.error_msg
                                                  : ReimburseRejectData?.errors
                                                      ?.reimbursement_account?.[0]}
                                                .
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                        "pending" ? (
                                        <div
                                          key={account?.id}
                                          className={`h-full flex justify-end w-full ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                service === "CBeneficiaryTxn" ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <TopNavSmallButton
                                            btnText={
                                              <>
                                                Reject <br /> account
                                              </>
                                            }
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service === "RAAccount" ||
                                                    service === "Admin",
                                                ) !== undefined
                                              ) {
                                                setSearchtype("rejectall");
                                                setAssociateType(
                                                  "rejectAccount",
                                                );
                                                setClickedBtn("reject");
                                                handleDeclinedDetials(
                                                  account?.id,
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "RAAccount",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            icon={
                                              ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE
                                            }
                                            isDisabled={
                                              services?.find(
                                                (service) =>
                                                  service === "RAAccount" ||
                                                  service === "Admin",
                                              ) !== undefined
                                                ? false
                                                : true
                                            }
                                            enabledBgColor={
                                              "var(--negative-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary"
                                            }
                                            hoverOption="black"
                                            fullWidthRequired={isMobile}
                                          />

                                          <TopNavSmallButton
                                            btnText={
                                              <>
                                                Approve <br /> account{" "}
                                              </>
                                            }
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service === "RAAccount" ||
                                                    service === "Admin",
                                                ) !== undefined
                                              ) {
                                                setClickedBtn("approve");
                                                handleApprovalDetails(
                                                  account?.id,
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "RAAccount",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            isDisabled={
                                              services?.find(
                                                (service) =>
                                                  service === "RAAccount" ||
                                                  service === "Admin",
                                              ) !== undefined
                                                ? false
                                                : true
                                            }
                                            icon={
                                              ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK
                                            }
                                            enabledBgColor={
                                              "var(--positive-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary"
                                            }
                                            hoverOption="black"
                                            fullWidthRequired={isMobile}
                                          />
                                        </div>
                                      ) : null}
                                    </>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="bene_quickaction_containerm block Qsmd:hidden">
                <div className="text-text-primary pl-padding-sm py-padding-button-l text-font-sm font-semibold bg-primary-card">
                  Quick Actions
                </div>
                <div>
                  <div>
                    <div
                      className="associated-account-transaction-history-block Qsmd:hidden flex flex-row border-b border-solid border-primary-bg bg-primary-nav-act"
                      style={{
                        borderTop: "none",
                      }}
                    >
                      <TopNavSmallButton
                        btnText={
                          <>
                            Linked <br /> user{" "}
                          </>
                        }
                        handleFunction={handleReimbursementLinkedUser}
                        icon={ICONS?.LINKED_WHITE_CIRCLE}
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          type === "reimburseacc_details"
                            ? true
                            : services?.find(
                                  (service) =>
                                    service === "VSpecificEmp" ||
                                    service === "Admin",
                                ) !== undefined &&
                                viewAccountDetailData
                                  ?.reimbursement_accounts?.[0]
                                  ?.reimbursement_user_full_name
                              ? false
                              : viewAccountDetailData
                                    ?.reimbursement_accounts?.[0]
                                    ?.reimbursement_user_full_name &&
                                  type !== "reimburseacc_details"
                                ? false
                                : true
                        }
                        fullWidthRequired={true}
                      />
                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>
                      <TopNavSmallButton
                        btnText={
                          <>
                            Associated <br /> accounts{" "}
                          </>
                        }
                        handleFunction={() => {
                          if (type === "reimburseacc_details") {
                            actionRestricted();
                            return;
                          }
                          openAssociatedAccountsFound();
                        }}
                        icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={type === "reimburseacc_details"}
                        fullWidthRequired={true}
                      />

                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>
                      <TopNavSmallButton
                        btnText={
                          <>
                            {" "}
                            Transaction <br /> history
                          </>
                        }
                        handleFunction={() => {
                          if (type === "reimburseacc_details") {
                            actionRestricted();
                            return;
                          }

                          if (ensureAll(["VReimbursementTxn"]).status) {
                            setShowHistoryPopup(true);
                            setTxnHistoryAccountName(
                              viewAccountDetailData?.reimbursement_accounts[0]
                                ?.bank_account_holder_full_name,
                            );
                            setTxnHistoryId(
                              viewAccountDetailData?.reimbursement_accounts[0]
                                ?.id,
                            );
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "VReimbursementTxn",
                              },
                            });
                            return;
                          }
                        }}
                        icon={ICONS?.TRANSACTION_HISTORY}
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          type === "reimburseacc_details" ||
                          !ensureAll(["VReimbursementTxn"]).status
                            ? true
                            : false
                        }
                        fullWidthRequired={true}
                      />
                    </div>
                    <div className="settingsm flex flex-row bg-primary-nav-act">
                      <TopNavSmallButton
                        btnText={
                          <>
                            {" "}
                            Request <br /> history
                          </>
                        }
                        handleFunction={() => {
                          if (type === "reimburseacc_details") {
                            actionRestricted();
                            return;
                          }
                          if (ensureAll(["VReimbursementTxn"]).status) {
                            setRequestHistory(true);
                            setTxnHistoryAccountName(
                              viewAccountDetailData?.reimbursement_accounts[0]
                                ?.bank_account_holder_full_name,
                            );
                            setTxnHistoryId(
                              viewAccountDetailData?.reimbursement_accounts[0]
                                ?.id,
                            );
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "VReimbursementTxn",
                              },
                            });
                            return;
                          }
                        }}
                        icon={ICONS?.TRANSACTION_HISTORY}
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          type === "reimburseacc_details" ||
                          !ensureAll(["VReimbursementTxn"]).status
                            ? true
                            : false
                        }
                        fullWidthRequired={true}
                      />

                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>
                      <TopNavSmallButton
                        btnText={
                          <>
                            {" "}
                            Edit <br /> account
                          </>
                        }
                        handleFunction={() => {
                          if (
                            viewAccountDetailData?.reimbursement_accounts?.[0]
                              .approval_status !== "archived" &&
                            viewAccountDetailData?.reimbursement_accounts?.[0]
                              .approval_status !== "blocked"
                          ) {
                            if (type === "reimburseacc_details") {
                              actionRestricted();
                            } else {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "RUAccount" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                dispatch(resetEditReimbursementAccount());
                                handleModalOpen(id);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "RUAccount",
                                  },
                                });
                              }
                            }
                          }
                        }}
                        icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          type === "reimburseacc_details"
                            ? true
                            : viewAccountDetailData?.reimbursement_accounts[0]
                                  .approval_status === "archived" ||
                                viewAccountDetailData
                                  ?.reimbursement_accounts?.[0]
                                  .approval_status === "blocked"
                              ? true
                              : services?.find(
                                    (service) =>
                                      service === "RUAccount" ||
                                      (service === "Admin" &&
                                        servicesType !== "BenAdmin"),
                                  ) !== undefined
                                ? false
                                : true
                        }
                        fullWidthRequired={true}
                      />

                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>

                      {viewAccountDetailData?.reimbursement_accounts[0]
                        .approval_status === "blocked" ||
                      services?.find(
                        (service) =>
                          service === "RAAccountArchive" || service === "Admin",
                      ) === undefined ? (
                        <>
                          <TopNavSmallButton
                            btnText={label}
                            handleFunction={() => {
                              if (
                                viewAccountDetailData?.reimbursement_accounts[0]
                                  .approval_status !== "blocked"
                              ) {
                                if (
                                  services?.find(
                                    (service) =>
                                      service === "RAAccountArchive" ||
                                      service === "Admin",
                                  ) !== undefined
                                ) {
                                  handleUnarchive();
                                  handleArchive();
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "RAAccountArchive",
                                    },
                                  });
                                }
                              }
                            }}
                            icon={
                              services?.find(
                                (service) =>
                                  service === "RAAccountArchive" ||
                                  service === "Admin",
                              ) === undefined &&
                              viewAccountDetailData?.reimbursement_accounts[0]
                                .approval_status === "archived"
                                ? ICONS?.UNARCHIVE
                                : ICONS?.ARCHIVE
                            }
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary"}
                            hoverOption="white"
                            isDisabled={
                              type === "reimburseacc_details" ||
                              viewAccountDetailData?.reimbursement_accounts[0]
                                .approval_status === "blocked" ||
                              services?.find(
                                (service) =>
                                  service === "RAAccountArchive" ||
                                  service === "Admin",
                              ) === undefined
                            }
                            fullWidthRequired={true}
                          />
                        </>
                      ) : (
                        <TopNavSmallButton
                          btnText={
                            viewAccountDetailData?.reimbursement_accounts[0]
                              .approval_status === "archived" ? (
                              <>
                                Unarchive <br /> account{" "}
                              </>
                            ) : (
                              <>
                                Archive <br /> account{" "}
                              </>
                            )
                          }
                          handleFunction={() => {
                            if (
                              viewAccountDetailData?.reimbursement_accounts[0]
                                .approval_status !== "blocked"
                            ) {
                              if (type === "reimburseacc_details") {
                                actionRestricted();
                              } else if (
                                services?.find(
                                  (service) =>
                                    service === "RAAccountArchive" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                handleUnarchive();
                                handleArchive();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "RAAccountArchive",
                                  },
                                });
                              }
                            }
                          }}
                          fullWidthRequired={true}
                          icon={
                            viewAccountDetailData?.reimbursement_accounts[0]
                              .approval_status === "archived"
                              ? ICONS?.UNARCHIVE
                              : ICONS?.ARCHIVE
                          }
                          enabledBgColor={"var(--primary-nav-act)"}
                          enabledTextColor={"var(--text-primary"}
                          hoverOption="white"
                          isDisabled={type === "reimburseacc_details"}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`bg-primary-bg flex-grow w-full ${type === "reimburseacc_details" && "pb-padding-lg"}`}
              >
                <div className=" bg-primary-card mb-margin-md Qsmd:mb-margin-base">
                  <div className="  w-full lg:w-max-content-width m-auto">
                    <CommonAlertsStrip alerts={buildAlerts()} />
                  </div>
                </div>

                <div className="h-auto max-w-tab-width-normal bg-primary-bg m-auto pb-padding-md">
                  <div className="z-z-index-base relative detail-category-button flex Qsmd:pt-padding-md pb-padding-md px-padding-md lg:px-padding-base">
                    <div
                      ref={switcherScrollRef}
                      className=" overflow-x-auto"
                      style={{
                        scrollbarWidth: "none",
                      }}
                    >
                      <SwitcherTabs
                        initialActiveTab={switcherTabs[index].key}
                        tabs={switcherTabs}
                        swicherTabBgColor={"var(--primary-card)"}
                        setIndex={setIndex}
                      />
                    </div>
                  </div>
                  {index === GlobalConfiguration?.lengthCheckZero && (
                    <div className={animationClass}>
                      {viewAccountDetails?.map((account) => {
                        let originItemList = [
                          {
                            content: "+91 " + account?.contact_no ?? "",
                            heading: "Contact number",
                            type: "text",
                          },
                          {
                            content: account?.email_id?.toLowerCase(),
                            heading: "Email ID",
                            type: "text",
                          },
                        ];

                        let AccountItemList = [
                          {
                            content: account?.pan_no,
                            heading: globalText.PAN_NUMBER,
                            type: "text",

                            onClick: () => {
                              const hasAccess = services?.some(
                                (service) =>
                                  service === "VPAN" || service === "Admin",
                              );

                              if (hasAccess && account?.pan_no) {
                                if (type === "reimburseacc_details") {
                                  actionRestricted();
                                } else {
                                  handlePANDetails(account?.pan_no);
                                }
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: { unavailableService: "VPAN" },
                                });
                              }
                            },

                            isDisabled:
                              type === "reimburseacc_details"
                                ? true
                                : services?.some(
                                      (service) =>
                                        service === "VPAN" ||
                                        service === "Admin",
                                    ) &&
                                    account?.pan_no &&
                                    type !== "reimburseacc_details"
                                  ? false
                                  : true,
                          },

                          {
                            content: account?.pan_legal_name
                              ?.toLowerCase()
                              ?.split(" ")
                              ?.map(
                                (word) =>
                                  word
                                    .charAt(
                                      GlobalConfiguration?.lengthCheckZero,
                                    )
                                    .toUpperCase() +
                                  word.slice(
                                    GlobalConfiguration?.lengthCheckOne,
                                  ),
                              )
                              ?.join(" "),
                            heading: "Legal name",
                            type: "text",
                          },
                          {
                            content: account?.gstin_detail
                              ? account?.gstin_detail
                              : "Not given",
                            heading: globalText.GSTIN,
                            type: "text",
                            isDisabled:
                              services?.some(
                                (service) =>
                                  service === "VGSTIN" || service === "Admin",
                              ) && type !== "reimburseacc_details"
                                ? false
                                : true,

                            onClick: account?.gstin_detail
                              ? () => {
                                  if (type === "reimburseacc_details") {
                                    actionRestricted();
                                  } else {
                                    if (!account?.gstin_detail) return;

                                    const hasAccess =
                                      services?.includes("VGSTIN") ||
                                      services?.includes("Admin");
                                    if (hasAccess) {
                                      setGstShowPopup(true);
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: { unavailableService: "VGSTIN" },
                                      });
                                    }
                                  }
                                }
                              : undefined,
                          },
                        ];

                        if (account?.virtual_account === "Y") {
                          AccountItemList.push({
                            content:
                              account?.virtual_account_type === "manual"
                                ? "Manually created"
                                : account?.virtual_account_type === "automated"
                                  ? "Auto-detected"
                                  : account?.virtual_account_type
                                    ? account.virtual_account_type[0].toUpperCase() +
                                      account.virtual_account_type.slice(1)
                                    : "",
                            heading: "Virtual account",
                            type: "text",
                          });
                        }

                        AccountItemList.push({
                          content: account?.account_type,
                          heading: "Account state",
                          type: "text",
                        });

                        return (
                          <div
                            className={`flex flex-col lg:flex-row justify-start gap-gap-md mx-margin-md lg:mx-auto`}
                          >
                            <CommonDetailCard
                              cardTitle="Account Details"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={AccountItemList}
                            />
                            <CommonDetailCard
                              cardTitle="Contact Details"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={originItemList}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {index === GlobalConfiguration?.lengthCheckOne && (
                    <div className={animationClass}>
                      <CommonContainerCard
                        header={"Categories"}
                        icon={ICONS?.EDIT}
                        iconIsDisabled={
                          type === "reimburseacc_details" ||
                          !ensureAll(["RUAccount"]).status ||
                          viewAccountDetails[0].approval_status === "blocked" ||
                          viewAccountDetails[0].approval_status === "archived"
                            ? true
                            : false
                        }
                        handleFunction={(e) => {
                          e.stopPropagation();
                          if (type === "reimburseacc_details") {
                            actionRestricted();
                            return;
                          } else {
                            if (!ensureAll(["RUAccount"]).status) {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "RUAccount" },
                              });
                              return;
                            } else if (
                              viewAccountDetails[0].approval_status ===
                                "blocked" ||
                              viewAccountDetails[0].approval_status ===
                                "archived"
                            ) {
                              return;
                            } else {
                              navigate(
                                `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_categories/${id}`,
                                {
                                  state: previousContactDetails,
                                },
                              );
                            }
                          }
                        }}
                      >
                        {sliceCategory?.filter((item) => item.active === "Y")
                          .length === categoriesAssigned.length ? (
                          <div className="flex mb-margin-button-l items-center">
                            <img
                              className="w-icon-md h-icon-md mr-margin-sm"
                              src={ICONS?.ALERT}
                              alt="Not  found"
                            />
                            <p className="text-text-primary text-sm font-normal">
                              {TEXT?.ALL_CATEGORIES_ASSIGNED_WARNING}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        <div
                          className={`${
                            categoriesAssigned.length > 0
                              ? "assigned-beneficiary-categories-data-div"
                              : ""
                          }`}
                        >
                          <div key={1}>
                            <div className="flex flex-col Qmd:flex-row Qmd:flex-wrap gap-gap-md">
                              {categoriesAssigned
                                ? categoriesAssigned.map(
                                    ([category, id], categoryIndex) => {
                                      const categoryIcon = categoryMapper(id);
                                      return (
                                        <div
                                          className="w-full bg-primary-nav rounded-border-radius-md max-w-none Qmd:max-w-detail-page-category-card flex flex-row items-center"
                                          key={categoryIndex}
                                        >
                                          <div className="bg-text-primary rounded-tl-border-radius-md rounded-bl-border-radius-md flex justify-center items-center opacity-base-opacity">
                                            <div className="m-margin-sm max-w-none w-icon-lg h-icon-lg">
                                              <SVGComponent
                                                color={categoryIcon.colour}
                                                url={categoryIcon?.url}
                                                height={"var(--icon-lg)"}
                                                width="var(--icon-lg)"
                                              />
                                            </div>
                                          </div>
                                          <div className="truncate px-padding-sm text-font-sm text-text-primary text-left font-sans font-semibold opacity-base-opacity antialiased">
                                            <TickerAnimation
                                              text={category.trim()}
                                            />
                                          </div>
                                        </div>
                                      );
                                    },
                                  )
                                : null}
                            </div>
                            {!categoriesAssigned && (
                              <p
                                key={`notFound_${index}`}
                                className="antialiased text-text-primary text-sm"
                              >
                                {TEXT?.ASSIGN_CATEGORY_WARNING}
                              </p>
                            )}
                          </div>
                        </div>
                      </CommonContainerCard>
                    </div>
                  )}
                  {index === GlobalConfiguration?.lengthCheckTwo && (
                    <div className={animationClass}>
                      <CommonContainerCard
                        header="Labels"
                        subheader={TEXT?.LABELS_ACCOUNT_USAGE_NOTE}
                        handleFunction={(e) => {
                          e.stopPropagation();
                          if (
                            !services?.includes("ALabel") &&
                            !services?.includes("RLabel")
                          ) {
                            navigate("/feature_not_assigned", {
                              state: { unavailableService: "ALabel,RLabel" },
                            });
                            return;
                          }
                          if (type === "reimburseacc_details") {
                            actionRestricted();
                            return;
                          }

                          setShowLabelsPopup(true);
                        }}
                        icon={ICONS?.EDIT}
                        iconIsDisabled={type === "reimburseacc_details"}
                      >
                        <div className="flex flex-wrap w-full gap-gap-sm">
                          {Array.isArray(labelDetails) &&
                          labelDetails?.length >
                            GlobalConfiguration.lengthCheckZero ? (
                            <>
                              {labelDetails.map((item, index) => (
                                <Chips
                                  txtChip={item}
                                  enabledTextColor="var(--text-primary)"
                                  enabledBgColor="var(--primary-nav)"
                                  isTickerRequired={false}
                                />
                              ))}
                            </>
                          ) : (
                            <p className="text-font-sm text-text-primary">
                              Not assigned.
                            </p>
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  )}
                  {index === GlobalConfiguration?.lengthCheckThree && (
                    <div className={animationClass}>
                      <CommonContainerCard
                        header={TEXT?.ADDITIONAL_RECIPIENTS}
                        subheader={TEXT?.ADDITIONAL_RECIPIENTS_CARD_SUBTEXT}
                        icon={ICONS?.EDIT}
                        handleFunction={(e) => {
                          e.stopPropagation();
                          if (type === "reimburseacc_details") {
                            actionRestricted();
                            return;
                          } else {
                            if (!ensureAll(["RUAccount"]).status) {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "RUAccount" },
                              });
                              return;
                            } else if (
                              viewAccountDetails[0].approval_status ===
                                "archived" ||
                              viewAccountDetails[0].approval_status ===
                                "blocked"
                            ) {
                              return;
                            } else {
                              handleModalOpen(id);
                              setSelectedChipIndex(
                                GlobalConfiguration.lengthCheckThree,
                              );
                            }
                          }
                        }}
                        iconIsDisabled={
                          !ensureAll(["RUAccount"]).status
                            ? true
                            : type === "reimburseacc_details" ||
                                viewAccountDetails[0].approval_status ===
                                  "archived" ||
                                viewAccountDetails[0].approval_status ===
                                  "blocked"
                              ? true
                              : false
                        }
                      >
                        <div className="flex flex-wrap w-full gap-gap-sm">
                          {Array.isArray(showAdditionalRecipient) &&
                          showAdditionalRecipient?.length >
                            GlobalConfiguration.lengthCheckZero ? (
                            <>
                              {showAdditionalRecipient?.map((item, index) => (
                                <div
                                  key={index}
                                  className="flex flex-row items-center py-padding-button-m px-padding-button-l rounded-border-radius-md relative bg-primary-nav-act max-w-max_width-full"
                                >
                                  <span className="text-text-primary text-font-xs font-normal break-all">
                                    {linkIdentifier(item)}
                                  </span>
                                </div>
                              ))}
                            </>
                          ) : (
                            <span className="text-text-primary text-sm font-normal">
                              {TEXT?.NO_ADDITIONAL_RECIPIENTS_ADDED}
                            </span>
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckFour && (
                    <div className={animationClass}>
                      {viewAccountDetails?.map((account) => {
                        let originTimelineItemList = [
                          {
                            content: account?.created_by_name || "Not given",
                            heading: "Created by",
                            type: "text",
                          },
                          {
                            content: account?.created_on
                              ? formatDateViewAll(
                                  account.created_on,
                                  true,
                                  true,
                                )
                              : "Not given",
                            heading: "Created on",
                            type: "text",
                          },

                          // ✅ APPROVED
                          ...(account?.approval_status === "approved"
                            ? [
                                {
                                  content:
                                    account?.approved_by_name || "Not given",
                                  heading: "Approved by",
                                  type: "text",
                                },
                                {
                                  content: account?.approved_on
                                    ? formatDateViewAll(
                                        account?.approved_on,
                                        true,
                                        true,
                                      )
                                    : "Not given",
                                  heading: "Approved on",
                                  type: "text",
                                },
                              ]
                            : []),

                          // ✅ REJECTED
                          ...(account?.approval_status === "rejected"
                            ? [
                                {
                                  content:
                                    account?.rejected_by_name || "Not given",
                                  heading: "Rejected by",
                                  type: "text",
                                },
                                {
                                  content: account?.rejected_on
                                    ? formatDateViewAll(
                                        account?.rejected_on,
                                        true,
                                        true,
                                      )
                                    : "Not given",
                                  heading: "Rejected on",
                                  type: "text",
                                },
                                {
                                  content:
                                    account?.rejection_reason || "Not given",
                                  heading: "Rejected reason",
                                  type: "text",
                                },
                              ]
                            : []),

                          // ✅ ARCHIVED
                          ...(account?.approval_status === "archived"
                            ? [
                                {
                                  content:
                                    account?.archived === "Y" &&
                                    !account?.archived_by_name
                                      ? nameArchive
                                      : account?.archived_by_name ||
                                        "Not given",
                                  heading: "Archived by",
                                  type: "text",
                                },
                                {
                                  content: account?.archived_on
                                    ? formatDateViewAll(
                                        account?.archived_on,
                                        true,
                                        true,
                                      )
                                    : "Not given",
                                  heading: "Archived on",
                                  type: "text",
                                },
                              ]
                            : []),

                          // ✅ BLOCKED
                          ...(account?.approval_status === "blocked"
                            ? [
                                {
                                  content:
                                    account?.blocked_by_name || "Not given",
                                  heading: "Blocked by",
                                  type: "text",
                                },
                                {
                                  content: account?.blocked_on
                                    ? formatDateViewAll(
                                        account?.blocked_on,
                                        true,
                                        true,
                                      )
                                    : "Not given",
                                  heading: "Blocked on",
                                  type: "text",
                                },
                              ]
                            : []),
                        ];

                        let SupportInformationList = [
                          {
                            content: account?.id,
                            heading: "Account ID",
                            type: "textWithButton",
                            iconArray: [
                              {
                                onClick: (e) => {
                                  setSupportInfoTT("Copied");
                                  if (account?.id) {
                                    navigator.clipboard.writeText(account.id);
                                  }
                                  setTimeout(() => {
                                    setSupportInfoTT(supportInfoTTDefaultText);
                                  }, IntervalConfiguration.intervalMedium);
                                },
                                title: supportInfoTT,
                                icon:
                                  supportInfoTT === "Copied"
                                    ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                    : ICONS?.COPY,
                              },
                            ],
                          },
                        ];

                        return (
                          <div
                            className={`flex flex-col lg:flex-row justify-start gap-gap-md mx-margin-md lg:mx-auto`}
                          >
                            <CommonDetailCard
                              cardTitle="Origin Details"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={originTimelineItemList}
                            />
                            <CommonDetailCard
                              cardTitle="Support Information"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={SupportInformationList}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ReimbursementAccountDetails;
